import React, { useCallback } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, mainInformationPath, makeSearchPath } from '@/utils/index'
import { IBreadcrumb, ICustomer } from '@/types'
import { t } from '@/i18n'

import { useData } from './useData'
import Form from './form'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_customer',
  },
]

const AddCustomer: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { data, loading, submitting, onCancel, onSubmit } = useData({})

  const onSubmitForm = useCallback(
    (d: ICustomer) => {
      onSubmit('customers/customers/', false, res => {
        const viewPath = makeSearchPath(mainInformationPath, {
          customerId: res.id,
        })
        navigate(viewPath)
      })(d)
    },
    [navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_customer')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddCustomer
